import DividerElement from './DividerElement'
import WithDividerElement from './WithDividerElement'

export default DividerElement
export { WithDividerElement }
